import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { filterBySearch, filterBySort } from "../../features/jobs/jobsSlice";

export default function HeaderSearch({ type }) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      dispatch(filterBySearch(search));
    } else if (e.keyCode === 8 && search === "") {
      dispatch(filterBySearch(""));
    }
  };

  const handleSort = (e) => {
    dispatch(filterBySort(e.target.value));
  };
  return (
    <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
      <h1 className="section-title">
        All Available {type !== "All" ? type : ""} Jobs
      </h1>
      <div className="flex gap-4">
        <div className="search-field group flex-1">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input
            type="text"
            placeholder="Search Job"
            className="search-input"
            id="lws-searchJob"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => handleSearch(e)}
          />
        </div>
        <select
          id="lws-sort"
          name="sort"
          autoComplete="sort"
          className="flex-1"
          onChange={handleSort}
        >
          <option>Default</option>
          <option>Salary (Low to High)</option>
          <option>Salary (High to Low)</option>
        </select>
      </div>
    </div>
  );
}
